import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { BannerAlertService } from './banner-alert.service';

interface Alert {
  type: string;
  message: string;
}

@Component({
  selector: 'app-banner-alert',
  standalone: true,
  imports: [
    CommonModule,
    NgbAlertModule
  ],
  templateUrl: './banner-alert.component.html',
  styleUrls: ['./banner-alert.component.scss']
})
export class BannerAlertComponent implements OnInit {
  alerts: Alert[] = [];
  @Output() onAlertClose: EventEmitter<void> = new EventEmitter<void>(); // Create EventEmitter for alert close

  constructor(private bannerAlertService: BannerAlertService) {
    this.reset();
  }

  ngOnInit(): void {
    this.bannerAlertService.sharingData.subscribe((data: any) => {
      if (data.errorKeys && data.errorMessages) {
        this.addErrorAlerts(data.errorKeys, data.errorMessages);
      }
    });
  }

  close(alert: Alert) {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
    this.onAlertClose.emit(); // Emit event when an alert is closed
  }

  reset() {
    this.alerts = [];
  }

  addErrorAlerts(errorKeys: string[], errorMessages: string[]) {
    this.reset(); // Clear previous alerts
    errorKeys.forEach((key, index) => {
      this.alerts.push({
        type: 'danger', // Set alert type to 'danger' for errors
        message: `${key}: ${errorMessages[index]}` // Customize the message
      });
    });
  }
}
